<template>
<div>
   <nav class="navbar navbar-expand-md navbar-light fixed-top desktop navbar-topo" style="padding: 10px;">
      <div class="container">
        <a class="navbar-brand d-flex" href="#" v-if="urlTopo == null || empresa === 'conexa'"><img src="/assets/img/logo-header.svg" alt="" style="max-width: 180px; max-height: 61px;"></a>
        <a class="navbar-brand d-flex" href="#" v-if="urlTopo != null"><img :src="urlTopo" alt="" style="max-width: 180px; max-height: 61px;"></a>
        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div >
          <div class="ml-auto">
            <ul class="nav navbar-nav">
            </ul>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </nav>

    <nav class="navbar navbar-expand-lg fixed-top navbar-light navbar-offcanvas mobile mt-1 mb-2">
      <div class="container">
         <a class="navbar-brand mr-auto float-left" href="#" v-if="urlTopo == null"><img src="/assets/img/logo-header.svg" alt="" style="max-width: 180px; max-height: 61px;"></a>
         <a class="navbar-brand mr-auto float-left" href="#" v-if="urlTopo != null"><img :src="urlTopo" alt="" style="max-width: 180px; max-height: 61px;"></a>
      </div>
    </nav>
    <br>
    <br>
    <br>
  </div>  
  
</template>

<script>
export default {
  name: 'topo',
  props: ['empresa'],
  created(){
      if(this.empresa != null){
         sessionStorage.setItem("empresa", this.empresa)
      }
      if(sessionStorage.getItem("empresa") === 'conexa'){
         this.urlTopo = null
      } else if(sessionStorage.getItem("empresa") != null){
         this.urlTopo = "https://s3.sa-east-1.amazonaws.com/drvirtual/logos/b2c/logo-b2c-"+sessionStorage.getItem("empresa")+".png"
      }
  },
  data() {
     return { 
        urlTopo : null
     }
  }
}
</script>
<style>
.navbar-topo{
  z-index: 999;
}
</style>